/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class DeclineBalance {
  private json: any
  public readonly declineBalanceDisclaimer: string
  public readonly declineBalanceLabel: string
  public readonly declineBalanceTooltip: string

  constructor (data: any) {
    this.json = data
    this.declineBalanceDisclaimer = this.json.disclaimer
    this.declineBalanceLabel = this.json.label
    this.declineBalanceTooltip = this.json.tooltip
  }

  static of (data: any): DeclineBalance {
    return new DeclineBalance(data)
  }

  static empty (): DeclineBalance {
    return new DeclineBalance({
      disclaimer: '',
      label: '',
      tooltip: ''
    })
  }
}
